module.exports = __webpack_public_path__ + "img/edit_black.40f9d640.svg";